import { PdfViewer } from '../components/PdfViewer/PdfViewer';

export const TermsPage = () => (
  /*
  Create a static HMTL component
  */
  <PdfViewer oldPDF />
);

export const TermsPage2024 = () => (
  /*
  Create a static HMTL component
  */
  <PdfViewer />
);
